module.exports = __webpack_public_path__ + "static/media/capitulo.edfbf228.svg";